/**
*  범용 함수
* */


/* datepicker 로더 */
window.datepicker = function (  ) {
    $('.datepicker').datepicker({
        format: 'yyyy-mm-dd',
        language: 'ko'
    });
}

/*
 * 한글 영문 숫자 만 구분 해서 입력
 * CSS .inputOnlyKor
 * */
window.inputTypeCall = function (  ) {

    // 한글만 입력
    $('input.inputOnlyKor')
        .css('ime-mode', 'active')
        .keypress(function (e) {
            onlyKor(e, $(this));
        })
        .keyup(function (e) {
            onlyKor(e, $(this));
        })
        .focusout(function (e) {
            onlyKor(e, $(this));
        });

    // 한글/숫자만 입력
    $('input.inputOnlyKorNum')
        .css('ime-mode', 'active')
        .keypress(function (e) {
            onlyKorNum(e, $(this));
        })
        .keyup(function (e) {
            onlyKorNum(e, $(this));
        })
        .focusout(function (e) {
            onlyKorNum(e, $(this));
        });

    // 영문만 입력
    $('input.inputOnlyEng')
        .css('ime-mode', 'disabled')
        .keypress(function (e) {
            onlyEng(e, $(this));
        })
        .keyup(function (e) {
            onlyEng(e, $(this));
        })
        .focusout(function (e) {
            onlyEng(e, $(this));
        });

    // 숫자만 입력
    $('input.inputOnlyNum')
        .css('ime-mode', 'disabled')
        .keydown(function (e) {
            validCheck.keyDown(e, $(this));
        })
        .keyup(function (e) {
            validCheck.keyUp(e);
        })
        .focusout(function (e) {
            validCheck.focusOut($(this));
        });


    /* Cleave */
    $('input.numberFormat').toArray().forEach(function (field) {
        new Cleave(field, {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand'
        });
    });

    $('input.datepicker').toArray().forEach(function (field) {
        new Cleave(field, {
            delimiter: '-',
            blocks: [4, 2, 2]
        });
    });
    $('input.datepickerYMchg').toArray().forEach(function (field) {
        new Cleave(field, {
            delimiter: '-',
            blocks: [4, 2, 2]
        });
    });

    $('input.timepickerHM').toArray().forEach(function (field) {
        new Cleave(field, {
            time: true,
            timePattern: ['h', 'm']
        });
    });

    $('input.phonepicker').toArray().forEach(function (field) {
        new Cleave(field, {
            phone: true,
            phoneRegionCode: 'KR'
        });
    });
}



// 한글만 입력
window.onlyKor = function ( e, ele ) {
    var val = ele.val ();
    if ( ( e.keyCode < 12592 ) || ( e.keyCode > 12687 ) ) {
        e.returnValue = false;
    }
    if ( val.match ( /[^a-zA-Z]/g ) ) {
        ele.val ( val.replace ( /[a-z0-9]|[ \[\]{}()<>?|`~!@#$%^&*-_+=,.;:\"\\]/g, '' ) );
    }
}

// 한글/숫자만 입력
window.onlyKorNum = function ( e, ele ) {
    var val = ele.val ();
    if ( val.match ( /[^a-zA-Z]/g ) ) {
        ele.val ( val.replace ( /[a-z]/g, '' ) );
    }
}


// 영문만 입력
window.onlyEng = function ( e, ele ) {
    var val = ele.val ();
    if ( val.match ( /[^a-zA-Z]/g ) ) {
        ele.val ( val.replace ( /[^a-zA-Z]/g, '' ) );
    }else{
        e.returnValue = false;
    }
}



//#############숫자만 입력 ##########
window.OnlyNumber = function ( num ) {
    ins            = num.value;
    var pnumresult = '';
    for ( i = 0 ; i < ins.length ; i++ ) {
        charpnum = ins.substr ( i, 1 );
        if ( charpnum.charCodeAt ( 0 ) > 46 && charpnum.charCodeAt ( 0 ) < 58 )
            pnumresult = pnumresult + charpnum;
    }
    num.value = pnumresult;
    //if(ins == 0) p_num.value = '';
}

var validCheck = {
    keyDown : function ( e, ele ) {
        var key;
        if ( window.event )
            key = window.event.keyCode; //IE
        else
            key = e.which; //firefox
        var event;
        if ( key == 0 || key == 8 || key == 46 || key == 9 || key == 189 || key == 37 || key == 38 || key == 39 || key == 40 ) {
            event = e || window.event;
            if ( typeof event.stopPropagation != 'undefined' ) {
                event.stopPropagation ();
            } else {
                event.cancelBubble = true;
            }
            return;
        }
        if ( key < 48 || ( key > 57 && key < 96 ) || key > 105 || e.shiftKey ) {
            e.preventDefault ? e.preventDefault () : e.returnValue = false;
        }
        if ( key === 13 ) {
            eval ( ele.attr ( 'enter-event' ) + '()' );
        }
    },
    keyUp   : function ( e ) {
        var key;
        if ( window.event )
            key = window.event.keyCode; //IE
        else
            key = e.which; //firefox
        var event;
        event = e || window.event;
        if ( key == 8 || key == 46 || key == 37 || key == 39 )
            return;
        else
            event.target.value = event.target.value.replace ( /[^0-9]/g, '' );
    },
    focusOut: function ( ele ) {
        ele.val ( ele.val ().replace ( /[^0-9]/g, '' ) );
    }
};




/*
 * PHP 함수 number_format 같이 천자리마다 ,를 자동으로 찍어줌
 * @param num number|string : 숫자
 * @param decimals int default 0 : 보여질 소숫점 자리숫
 * @param dec_point char default . : 소수점을 대체 표시할 문자
 * @param thousands_sep char default , : 천자리 ,를 대체 표시할 문자
 * @returns {string}
 */
window.number_format = function ( num, decimals, dec_point, thousands_sep ) {
    num = parseFloat ( num );
    if ( isNaN ( num ) ) return '0';

    if ( typeof( decimals ) == 'undefined' ) decimals = 0;
    if ( typeof( dec_point ) == 'undefined' ) dec_point = '.';
    if ( typeof( thousands_sep ) == 'undefined' ) thousands_sep = ',';
    decimals = Math.pow ( 10, decimals );

    num = num * decimals;
    num = Math.round ( num );
    num = num / decimals;

    num     = String ( num );
    var reg = /(^[+-]?\d+)(\d{3})/;
    var tmp = num.split ( '.' );
    var n   = tmp[ 0 ];
    var d   = tmp[ 1 ] ? dec_point + tmp[ 1 ] : '';

    while ( reg.test ( n ) ) n = n.replace ( reg, '$1' + thousands_sep + '$2' );

    return n + d;
}


// 세팅 체크
window.isset = function () {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: FremyCompany
    // +   improved by: Onno Marsman
    // +   improved by: Rafał Kukawski
    // *     example 1: isset( undefined, true);
    // *     returns 1: false
    // *     example 2: isset( 'Kevin van Zonneveld' );
    // *     returns 2: true
    var a = arguments,
        l = a.length,
        i = 0,
        undef;

    if ( l === 0 ) {
        throw new Error ( 'Empty isset' );
    }

    while ( i !== l ) {
        if ( a[ i ] === undef || a[ i ] === null ) {
            return false;
        }
        i++;
    }
    return true;
}


/* 줄바꿈 html 치환 */
window.nl2br = function (str){
    var data ='';
    if( str != null) {
        data = str.replace(/\n/g, "<br />");
    }
    return data;
}


/* 전체 치환 */
window.replaceAll = function (source, searchStr, replaceStr) {
    return source.split(searchStr).join(replaceStr);
}





/* 계층 구조의 선택 상자 - 서브 리스트 셀렉터 */
window.subListChanged = function (mainList, subList) {
    $(subList).empty();
    var subs = '';
    subs = $(mainList).find(':selected').data('lists');
    subs = replaceAll(subs, ' ', '');
    subs = subs.split(',');
    for( const sub in subs ){
        if( subs[sub].length > 1 ) {
            var subData = subs[sub].split(':');
            $(subList).append('<option value="'+subData[0]+'" data-content="<span class=\'badge badge-success\'>'+subData[0]+'</span> '+subData[1]+'"></option>');
        }
    }
    $(subList).selectpicker('refresh');
}

/* 국가 리스트 선택시 도시 리스트 생성 */
$("#countryList").change( function(){
    subListChanged("#countryList", "#cityList");
} );



/* 테이블 rowspan */
window.genRowspan = function(className){
    $("." + className).each(function() {
        var rows = $("." + className + ":contains('" + $(this).text() + "')");
        if (rows.length > 1) {
            rows.eq(0).attr("rowspan", rows.length);
            rows.not(":eq(0)").remove();
        }
    });
}


/* 삭제 경고 */